<template>
	<div>
		<ja-button
			v-if="isFinalizeBudgetVisible"
			class="small btn--gradient"
			name="finalizeBudget"
			:value="$t('finalizeBudget')"
			@click.native="finalizeBudget"
			>{{ $t('finalizeBudget') }}
		</ja-button>

		<ja-button
			v-else-if="showCompleteLifeStageButton"
			class="small btn--gradient"
			name="applyFilters"
			:value="$t('completeLifeStage')"
			:disabled="completeLifeStageButtonDisabled"
			@click.native="finishLifeStage"
			>{{ $t('completeLifeStage') }}
		</ja-button>

		<ja-button
			v-else-if="isFinalizeShoppingVisible"
			class="small btn--gradient"
			name="finalizeShopping"
			:value="$t('finalizeShopping')"
			@click.native="finalizeShopping"
			>{{ $t('finalizeShopping') }}
		</ja-button>
	</div>
</template>

<script>
import { Button } from '@/components/ui';
import LifeStageService from '@/services/LifeStageService';
import { ProfileData, LifeStageData, UserData } from '@/mixins';

export default {
	components: {
		jaButton: Button
	},
	mixins: [ProfileData, LifeStageData, UserData],
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		completeLifeStageButtonDisabled: {
			type: Boolean,
			default: false
		},
		finalizeShoppingVisibility: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isCompleteButtonEnabled: false
		};
	},
	computed: {
		showCompleteLifeStageButton() {
			if (this.isInBudgetingPhase) {
				return false;
			}

			const minMandatoryCategoriesPercentage = 100;
			const completedLifeStagePercentage = 100;

			return (
				this.isCompleteButtonEnabled &&
				this.profileData.cmsLifeStage.displayOrder > 1 &&
				this.lifeStageData.mandatoryCategoriesCompletionPercentage >=
					minMandatoryCategoriesPercentage &&
				this.lifeStageData.currentLifeStageCompletionPercentage <
					completedLifeStagePercentage
			);
		},
		isFinalizeBudgetVisible() {
			let appliedForLoan = true;

			if (
				this.isLoanRequired &&
				(!this.$store.getters.isAutoLoanApplied ||
					!this.$store.getters.isMortgageLoanApplied)
			) {
				appliedForLoan = false;
			}

			return (
				this.$store.getters.areAllBudgetsSet &&
				this.isInBudgetingPhase &&
				appliedForLoan
			);
		},
		isFinalizeShoppingVisible() {
			return this.finalizeShoppingVisibility;
		}
	},
	watch: {
		showCompleteLifeStageButton(value) {
			if (value) {
				this.announceCompleteButton();
			}
		}
	},
	created() {
		LifeStageService.getSimCompleteLifeStageStatus(
			this.userData.userActiveSimulationId
		).then(response => {
			this.isCompleteButtonEnabled = response;
		});
	},
	mounted() {
		if (this.showCompleteLifeStageButton) {
			this.announceCompleteButton();
		}
	},
	methods: {
		announceCompleteButton() {
			setTimeout(() => {
				if (!this.disabled) {
					this.$announcer.polite(this.$t('completeButtonAppeared'));
				}
			}, 300);
		},
		finishLifeStage() {
			this.$emit('toggleCompleteLSBtnState');
		},
		finalizeBudget() {
			this.$emit('toggleFinalizeBudgetModal');
		},
		finalizeShopping() {
			this.$emit('toggleFinalizeShoppingModal');
		}
	}
};
</script>

<style></style>
